var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 66,
    viewBox: "0 0 46 66",
    fill: "#FF6B00",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 23C0.75 10.7117 10.7117 0.75 23 0.75C35.2883 0.75 45.25 10.7117 45.25 23C45.25 34.6143 36.3513 44.1501 25 45.1613V52.5H34.25C35.3546 52.5 36.25 53.3954 36.25 54.5C36.25 55.6046 35.3546 56.5 34.25 56.5H25V63.5C25 64.6046 24.1046 65.5 23 65.5C21.8954 65.5 21 64.6046 21 63.5V56.5H11.75C10.6454 56.5 9.75 55.6046 9.75 54.5C9.75 53.3954 10.6454 52.5 11.75 52.5H21V45.1613C9.64873 44.1501 0.75 34.6143 0.75 23ZM23 4.75C12.9208 4.75 4.75 12.9208 4.75 23C4.75 33.0792 12.9208 41.25 23 41.25C33.0792 41.25 41.25 33.0792 41.25 23C41.25 12.9208 33.0792 4.75 23 4.75Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/female-icon.326efebe0e8fb247c0a930c6c0f397cc.svg";
export { ForwardRef as ReactComponent };